var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"message-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"message",class:_vm.typeClass,attrs:{"role":"alert"}},[_c('p',{staticClass:"message__content"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }